const SET_IS_SHOWING_SPONSORSHIPS_TUTORIAL_MODAL =
  'sponsorshipsTutorialModalScreen/SET_IS_SHOWING_SPONSORSHIPS_TUTORIAL_MODAL';
const SET_IS_ONLY_SHOWING_TUTORIAL =
  'sponsorshipsTutorialModalScreen/SET_IS_ONLY_SHOWING_TUTORIAL';
const SET_SPONSORSHIPS_TUTORIAL_MODAL_AUTOPAIR_CAMPAIGN_ID =
  'sponsorshipsTutorialModalScreen/SET_SPONSORSHIPS_TUTORIAL_MODAL_AUTOPAIR_CAMPAIGN_ID';
const SET_IS_SHOWING_WAITING_SCENE =
  'sponsorshipsTutorialModalScreen/SET_IS_SHOWING_WAITING_SCENE';

export default {
  SET_IS_SHOWING_SPONSORSHIPS_TUTORIAL_MODAL,
  SET_SPONSORSHIPS_TUTORIAL_MODAL_AUTOPAIR_CAMPAIGN_ID,
  SET_IS_ONLY_SHOWING_TUTORIAL,
  SET_IS_SHOWING_WAITING_SCENE,
};
